import {AbstractControl, ValidationErrors} from '@angular/forms';

export function minimumArrayLengthValidator(minRequired: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (Array.isArray(value) && value.length >= minRequired) {
      return null; // No error
    }

    return {minimumSelected: {required: minRequired, actual: value.length}};
  };
}
